import React from 'react';
import {
  Create,
  SimpleForm,
  SelectInput,
  FormDataConsumer,
  required,
  useGetList,
  Toolbar,
  SaveButton,
  TextInput,
  usePermissions,
} from 'react-admin';
import { useFormContext } from 'react-hook-form';

import SendIcon from '@mui/icons-material/Send';
import { Box, Card, CardContent } from '@mui/material';

import { requestCreateMap } from '../../constants/requestFeatures';
import useRequestTypesChoices from '../../hooks/useRequestTypesChoices';
import cleaner from '../../utilities/dataProvider/cleaner';
import { RequestTypes } from '../../constants/requestTypes';
import actions, { Actions } from '../../constants/actions';
import hasAccess from '../../utilities/hasAccess';

type RequestFormCreate = {
  requestType?: RequestTypes;
  process?: string;
  customId?: string;
}

const CustomToolbar = () => {
  const { formState: { isValid } } = useFormContext();

  return (
    <Toolbar>
      <SaveButton
        label="Send"
        icon={<SendIcon />}
        disabled={!isValid}
      />
    </Toolbar>
  );
};

const RequestCreate = () => {
  const { data } = useGetList('processes', { filter: { active: true } });
  const { choices } = useRequestTypesChoices();
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Create transform={cleaner}>
      <Card variant="outlined">
        <CardContent>
          <SimpleForm mode="all" toolbar={<CustomToolbar />} component={Box}>
            <SelectInput
              source="requestType"
              label="Request type"
              choices={choices}
              validate={required()}
            />
            <FormDataConsumer<RequestFormCreate>>
              {({ formData }) => formData?.requestType && requestCreateMap[formData.requestType]()}
            </FormDataConsumer>
            {hasAccess(permissions, actions.PROCESS_LIST) && (
              <SelectInput
                optionValue="id"
                source="process"
                choices={data ?? []}
                optionText="name"
                validate={required()}
              />
            )}
            <TextInput sx={{ minWidth: 200 }} source="customId" label="Custom ID" />

          </SimpleForm>
        </CardContent>
      </Card>
    </Create>
  );
};

export default RequestCreate;
